import React from 'react';
import KeyMessagesList from '../components/KeyMessages/KeyMessagesList';

function KeyMessages() {
  return (
    <div className="key-messages-page">
      <KeyMessagesList />
    </div>
  );
}

export default KeyMessages; 